export default {
  api: `${process.env["APP_API_BASEURL"] ?? "http://localhost:5000"}`,
};
